// NPM Imports
import React from "react";
import { connect } from "react-redux";

// Component Imports
import ComponentView from "../ComponentView";
import PlusButtonAddComponentsV2 from "../../DocumentComponents/PlusButtonAddComponentsV2";

// Internal Imports
import { DOCUMENTS } from "../../../constants";

// Destructuring
const {
  POSITION_WISE_DOC_SECTION_DROP_PLACEHOLDER,
  POSITION_WISE_DOC_SECTION_PLUS_BUTTON_PLACEHOLDER,
  SECTION_AND_POSITION_WISE_PLACEHOLDER,
} = DOCUMENTS;

class DocumentRow extends React.Component {
  documentComponentRefs = {};

  state = {
    showAddComponentBtns: false,
    clickedPlusBtnPosition: null,
    clickedPlusBtnSectionId: null,
    isTableOptionsDDOpen: false,
    hoverPlusBtn: "ALL",
    showRowPlusBtnClassName: "",
    showColPlusBtnClassName: "",
    hoveredComponentId: "",
    showResetPlusBtnClassName: false,
    tableColorpickerDropdown: false,
  };

  _handlePlusBtnHover = (event, position) => {
    if (!this.props.isLocked) {
      event.stopPropagation();
      if (this.state.hoverPlusBtn !== position) {
        this.setState({ hoverPlusBtn: position });
      }
    }
  };

  _handleOnMouseOver = (event, colId) => {
    if (!this.props.isLocked) {
      if (
        event.target &&
        this.documentComponentRefs &&
        this.documentComponentRefs[colId]
      ) {
        const ele = this.documentComponentRefs[colId];

        if (ele && ele.getBoundingClientRect()) {
          // Get the Element Box positions with respect to view port
          const eleBox = ele.getBoundingClientRect();
          const eleLeft = eleBox.left;
          const eleTop = eleBox.top;

          // Get the mouse point's x and y position with respect to current hovered element
          const eleX = event.clientX - eleLeft;
          const eleY = event.clientY - eleTop;

          // min hover width and height
          let minHoverHeight = "100";
          let minHoverWidth = "125";

          if (ele.clientHeight <= 200) {
            minHoverHeight = "45";
          }
          if (ele.clientWidth <= 200) {
            minHoverWidth = "75";
          }

          let showColPlusBtnClassName = "";
          let showRowPlusBtnClassName = "";

          if (ele.clientWidth <= 150 && ele.clientHeight <= 150) {
            if (
              !this.state.showResetPlusBtnClassName &&
              ele.clientHeight <= 150
            ) {
              this.setState({ showResetPlusBtnClassName: true });
            }
          } else {
            // ------------ For width ------------
            if (ele.clientWidth <= 150) {
              showColPlusBtnClassName = "show-left-right-plus-buttons";
            } else {
              if (eleX <= minHoverWidth) {
                showColPlusBtnClassName = "show-left-plus-button";
              }
              if (ele.clientWidth - eleX <= minHoverWidth) {
                showColPlusBtnClassName = "show-right-plus-button";
              }
            }
            // ------------ For height ------------
            if (ele.clientHeight <= 80) {
              showRowPlusBtnClassName = "show-top-bottom-plus-buttons";
            } else {
              if (eleY <= minHoverHeight) {
                showRowPlusBtnClassName = "show-top-plus-button";
              }
              if (ele.clientHeight - eleY <= minHoverHeight) {
                showRowPlusBtnClassName = "show-bottom-plus-button";
              }
            }
          }

          if (
            showColPlusBtnClassName &&
            this.state.showColPlusBtnClassName !== showColPlusBtnClassName
          ) {
            this.setState({
              showColPlusBtnClassName,
              hoveredComponentId: colId,
            });
          }
          if (
            showRowPlusBtnClassName &&
            this.state.showRowPlusBtnClassName !== showRowPlusBtnClassName
          ) {
            this.setState({
              showRowPlusBtnClassName,
            });
          }
        }
      }
    }
  };

  _updateAddComponentBtnsFlag = (position, sectionID) => {
    this.setState(prevState => {
      if (position) {
        // Here have to handle 3 scenerios
        // 1. If clicking on same plus button
        if (
          prevState.clickedPlusBtnPosition === position &&
          prevState.clickedPlusBtnSectionId === sectionID
        ) {
          return {
            showAddComponentBtns: !prevState.showAddComponentBtns,
            clickedPlusBtnPosition: null,
            clickedPlusBtnSectionId: null,
          };
        }
        // 2. If clicking on other plus button for the 1'st time
        return {
          showAddComponentBtns: true,
          clickedPlusBtnPosition: position,
          clickedPlusBtnSectionId: sectionID,
        };
      }
      // 3. If clicking on outside of <PlusButtonAddComponents />
      return {
        showAddComponentBtns: false,
        clickedPlusBtnPosition: null,
        clickedPlusBtnSectionId: null,
      };
    });
  };

  _disablePlusBtnHandler = flag => {
    if (this.state.isTableOptionsDDOpen !== flag) {
      this.setState({
        isTableOptionsDDOpen: flag,
      });
    }
  };

  _getUpdatedRowColIndex = (
    position,
    currentRowIndex,
    currentColIndex,
    dbRowIndex,
    dbColIndex,
  ) => {
    let nextRowIndex = currentRowIndex;
    let nextDBRowIndex = dbRowIndex;
    let nextColIndex = 0;
    let nextDBColIndex = 0;
    if (position === "top") {
      nextRowIndex = currentRowIndex;
    } else if (position === "bottom") {
      nextRowIndex = currentRowIndex + 1;
      nextDBRowIndex = dbRowIndex + 1;
    } else if (position === "left") {
      nextColIndex = currentColIndex;
      nextDBColIndex = dbColIndex;
    } else if (position === "right") {
      nextColIndex = currentColIndex + 1;
      nextDBColIndex = dbColIndex + 1;
    }
    return {
      rowIndex: nextRowIndex === -1 ? 0 : nextRowIndex,
      colIndex: nextColIndex,
      dbRowIndex: nextDBRowIndex,
      dbColIndex: nextDBColIndex,
    };
  };

  _isHovered = () =>
    this.props.hoveredComponentID &&
    Array.isArray(this.props.rowList) &&
    this.props.rowList.includes(this.props.hoveredComponentID);

  _isDraggedOver = (componentId, rowColType) => {
    const { draggedSection, dragggedOverData, rowIndex } = this.props;
    let isDragggedOver = false;
    if (
      draggedSection &&
      dragggedOverData &&
      dragggedOverData.blockType === this.props.blockType &&
      dragggedOverData.rowIndex === rowIndex
    ) {
      if (rowColType === "ROW") {
        isDragggedOver = true;
      } else if (
        rowColType === "COLUMN" &&
        dragggedOverData.columnId === componentId
      ) {
        isDragggedOver = true;
      }
    }
    return isDragggedOver;
  };

  _onPlaceholderDragOver = e => {
    e.preventDefault();
    e.stopPropagation();
  };

  _onPlaceholderDragLeave = e => {
    e.preventDefault();
    e.stopPropagation();
    // this.props.onPlaceholderDragLeave();
  };

  _onPlaceholderDragEnter = (e, newDraggedOverData, draggedPosition) => {
    e.preventDefault();
    e.stopPropagation();

    this.props.onPlaceholderDragEnter(newDraggedOverData, draggedPosition);
  };

  _handleComponentBodyDrop = (
    e,
    componentType,
    position,
    rowIndexPosition,
    colIndexPosition,
    isNewRow,
    dbRowIndex,
    dbColIndex,
  ) => {
    if (this.props.draggedSection) {
      const { blockType, draggedSection } = this.props;
      if (blockType === "COVERPAGE") {
        if (
          componentType &&
          SECTION_AND_POSITION_WISE_PLACEHOLDER[componentType][
            blockType
          ].includes(position) &&
          SECTION_AND_POSITION_WISE_PLACEHOLDER[draggedSection.type][
            blockType
          ].includes(position)
        ) {
          this._onPlaceholderDrop(
            e,
            position,
            rowIndexPosition,
            colIndexPosition,
            isNewRow,
            dbRowIndex,
            dbColIndex,
          );
        }
      } else {
        this._onPlaceholderDrop(
          e,
          position,
          rowIndexPosition,
          colIndexPosition,
          isNewRow,
          dbRowIndex,
          dbColIndex,
        );
      }
    }
  };

  _onPlaceholderDrop = (
    e,
    position,
    rowIndexPosition,
    colIndexPosition,
    isNewRow,
    dbRowIndexPosition,
    dbColIndexPosition,
  ) => {
    e.preventDefault();
    e.stopPropagation();
    // Get the new ROW/COl index based on position
    const {
      rowIndex,
      colIndex,
      dbRowIndex,
      dbColIndex,
    } = this._getUpdatedRowColIndex(
      position,
      rowIndexPosition,
      colIndexPosition,
      dbRowIndexPosition,
      dbColIndexPosition,
    );
    this.props.onPlaceholderDrop(
      rowIndex,
      colIndex,
      isNewRow,
      dbRowIndex,
      dbColIndex,
    );
  };

  _getAddComponentFunc = (
    position,
    rowIndexPosition,
    colIndexPosition,
    isNewRow,
    dbRowIndexPosition,
    dbColIndexPosition,
  ) => component => {
    // Get the new ROW/COl index based on position
    const {
      rowIndex,
      colIndex,
      dbRowIndex,
      dbColIndex,
    } = this._getUpdatedRowColIndex(
      position,
      rowIndexPosition,
      colIndexPosition,
      dbRowIndexPosition,
      dbColIndexPosition,
    );
    this.props.addComponent(
      component,
      rowIndex,
      colIndex,
      isNewRow,
      dbRowIndex,
      dbColIndex,
    );
    if (this.state.hoverPlusBtn !== "ALL") {
      this.setState({ hoverPlusBtn: "ALL" });
    }
  };

  _getPlusButtonAddComponentBtn = (
    position,
    rowColumnId,
    rowIndexPosition,
    colIndexPosition,
    isNewRow,
    dbRowIndex,
    dbColIndex,
    totalRowItems,
  ) => {
    const {
      hoveredActiveComponentId,
      itemType,
      section,
      isLocked,
      emptyBlockConfig,
      coverpageSection,
      isComponentActive,
      headerFooterSection,
      showDocumentDiffView,
      updateDocumentSection,
      updateHoveredSectionId,
      docComponentSectionList: docSecList,
    } = this.props;

    let className = "documentrow-plusbuttonaddcomponent-wrapper ";
    if (position === "top" || position === "bottom") {
      className += ` top-bottom-position ${position}`;
    } else if (position === "left" || position === "right") {
      className += " left-right-position ";

      if (position === "left" && colIndexPosition === 0) {
        className += " first-left-right-position ";
      }
      if (position === "right" && colIndexPosition === totalRowItems - 1) {
        className += " last-left-right-position ";
      }
      className += ` ${position} `;
    }

    if (
      emptyBlockConfig &&
      emptyBlockConfig.flag &&
      (emptyBlockConfig.type === "HEADER" || emptyBlockConfig.type === "FOOTER")
    ) {
      className += " empty-header-footer ";
    }

    if (isComponentActive) {
      className += " show-plusbuttonaddcomponent-wrapper ";
    }

    const addComponentFunc = this._getAddComponentFunc(
      position,
      rowIndexPosition,
      colIndexPosition,
      isNewRow,
      dbRowIndex,
      dbColIndex,
    );
    let plusBtnClassName = "";
    if (
      !this.props.draggedSection &&
      emptyBlockConfig &&
      emptyBlockConfig.flag
    ) {
      if (
        emptyBlockConfig.type === "COVERPAGE" ||
        emptyBlockConfig.type === "BODY"
      ) {
        plusBtnClassName += "empty-component-image";
      } else if (
        emptyBlockConfig.type === "HEADER" ||
        emptyBlockConfig.type === "FOOTER"
      ) {
        plusBtnClassName += "empty-component-blank";
      }
    }
    if (
      !isLocked &&
      !showDocumentDiffView &&
      (!this.props.draggedSection || this.props.draggedFrom === "new-component")
    ) {
      return (
        <div className={className}>
          <PlusButtonAddComponentsV2
            data-test="plus-button-add-components-v2"
            className={plusBtnClassName}
            docID={this.props.docID}
            mode={this.props.mode}
            section={section}
            blockType={this.props.blockType}
            components={this.props.components}
            rowColumnId={rowColumnId}
            hoveredActiveComponentId={hoveredActiveComponentId}
            itemType={itemType}
            docSecList={docSecList}
            addComponent={addComponentFunc}
            coverpageSection={coverpageSection}
            headerFooterSection={headerFooterSection}
            updateDocumentSection={updateDocumentSection}
            showEditPane={this._showEditPane}
            updateAddComponentinToolbarAction={
              this.props.updateAddComponentinToolbarAction
            }
            updateHoveredSectionId={updateHoveredSectionId}
            showAddComponentBtns={this.state.showAddComponentBtns}
            updateAddComponentBtnsState={this._updateAddComponentBtnsFlag}
            updateDocumentClickedComponentID={
              this.props.updateDocumentClickedComponentID
            }
            position={position}
            clickedPlusBtnPosition={this.state.clickedPlusBtnPosition}
            clickedPlusBtnSectionId={this.state.clickedPlusBtnSectionId}
            isFirstBlock={colIndexPosition === 0}
            isLastBlock={colIndexPosition === totalRowItems - 1}
            hoverPlusBtn={this.state.hoverPlusBtn}
            handlePlusBtnHover={this._handlePlusBtnHover}
            isTableOptionsDDOpen={this.state.isTableOptionsDDOpen}
          />
        </div>
      );
    }
    return null;
  };

  /**
   * ::::::: GET THE ALL PLUS BUTTON PLACEHOLDERS FOR SPECIFIED POSITIONS AND
   *         BY COMPONENT TYPE & BY BLOCK TYPE(EX: BODY, COVERPAGE, ETC) ::::::
   * @param {*} rowColType     :: to get the required positions of placeholder(ROW/COLUMN wise)
   * @param {*} componentId    :: componentId for "COLUMN" & rowIndex for "ROW"
   * @param {*} positionType   :: to know whether it is for normal positon or specific posiotn(ex: first row/column)
   * @param {*} componentType  :: to show the placeholder if the component add block & it is only for "COLUMN"
   * @param {*} rowIndexPosition  :: the row index position where this placeholder is kept
   * @param {*} colIndexPosition  :: the column index position where this placeholder is kept
   */
  _getPlusButtonBlockPlaceholders = (
    rowColType,
    componentId,
    positionType,
    componentType,
    rowIndexPosition,
    colIndexPosition,
    isNewRow,
    dbRowIndex,
    dbColIndex,
    totalRowItems,
  ) => {
    let isActiveBlock = true;
    if (
      (this.props.blockType === "HEADER" ||
        this.props.blockType === "FOOTER") &&
      !this.props.isActiveHeaderFooter
    ) {
      isActiveBlock = false;
    }
    if (!this.props.isLocked && isActiveBlock) {
      const { blockType } = this.props;
      // Get the ROW/COLUMN wise placeholder positions
      const rowColWisePlaceholderPos =
        POSITION_WISE_DOC_SECTION_PLUS_BUTTON_PLACEHOLDER[rowColType];
      if (
        rowColWisePlaceholderPos &&
        rowColWisePlaceholderPos[positionType || "general"]
      ) {
        const placeholders = [];
        rowColWisePlaceholderPos[positionType || "general"].forEach(
          position => {
            const plusBtnPlaceholder = this._getPlusButtonAddComponentBtn(
              position,
              componentId,
              rowIndexPosition,
              colIndexPosition,
              isNewRow,
              dbRowIndex,
              dbColIndex,
              totalRowItems,
            );
            // GET the placeholder for COLUMN
            if (rowColType === "COLUMN") {
              // check if the component allows plus button placeholder for position & for block type
              if (
                componentType &&
                SECTION_AND_POSITION_WISE_PLACEHOLDER[componentType] &&
                SECTION_AND_POSITION_WISE_PLACEHOLDER[componentType][
                  blockType
                ].includes(position)
              ) {
                placeholders.push(plusBtnPlaceholder);
              }
            }
            // GET the placeholder for ROW
            else if (rowColType === "ROW") {
              placeholders.push(plusBtnPlaceholder);
            }
          },
        );
        if (placeholders && placeholders.length > 0) {
          return placeholders;
        }
      }
    }
    return null;
  };

  _getDropComponentPlaceholder = (
    position,
    componentId,
    rowIndexPosition,
    colIndexPosition,
    isNewRow,
    dbRowIndex,
    dbColIndex,
    totalRowItems,
  ) => {
    const { draggedPosition } = this.props;
    let className = "documentrow-dropcomponent-placeholder-wrapper ";
    if (position === "top" || position === "bottom") {
      className += ` top-bottom-position ${position}`;
    } else if (position === "left" || position === "right") {
      className += ` left-right-position ${position}`;
    }
    if (draggedPosition === position) {
      className += " active-placeholder ";
    }
    if (totalRowItems > 2) {
      className += " medium-size-placeholder ";
    }
    return (
      <div
        className={className}
        onDragOver={this._onPlaceholderDragOver}
        onDragEnter={event =>
          this._onPlaceholderDragEnter(
            event,
            {
              rowIndex: this.props.rowIndex,
              columnId: componentId,
              blockType: this.props.blockType,
            },
            position,
          )
        }
        onDragLeave={this._onPlaceholderDragLeave}
        onDrop={event =>
          this._onPlaceholderDrop(
            event,
            position,
            rowIndexPosition,
            colIndexPosition,
            isNewRow,
            dbRowIndex,
            dbColIndex,
          )
        }>
        <span className="documentrow-dropcomponent-placeholder-line" />
      </div>
    );
  };

  /**
   * ::::::: GET THE ALL DROP PLACEHOLDERS FOR SPECIFIED POSITIONS AND
   *         BY COMPONENT TYPE & BY BLOCK TYPE(EX: BODY, COVERPAGE, ETC) ::::::
   * @param {*} rowColType     :: to get the required positions of placeholder(ROW/COLUMN wise)
   * @param {*} positionType   :: to know whether it is for normal positon or specific posiotn(ex: first row/column)
   * @param {*} componentType  :: to show the placeholder if the component allow to drop the dragged block on it & it is only for "COLUMN"
   * @param {*} componentId    :: componentId for "COLUMN" & rowIndex for "ROW"
   * @param {*} isDragggedOver :: to know the dragged over component to show the placeholder
   */
  _getDropComponentPlaceholders = (
    rowColType,
    positionType,
    componentType,
    componentId,
    isDragggedOver,
    rowIndexPosition,
    colIndexPosition,
    isNewRow,
    dbRowIndex,
    dbColIndex,
  ) => {
    const { draggedSection, isLocked, blockType } = this.props;
    let isActiveBlock = true;
    if (
      (blockType === "HEADER" || blockType === "FOOTER") &&
      !this.props.isActiveHeaderFooter
    ) {
      isActiveBlock = false;
    }
    if (!isLocked && draggedSection && isDragggedOver && isActiveBlock) {
      // Get the ROW/COLUMN wise placeholder positions
      const rowColWisePlaceholderPos =
        POSITION_WISE_DOC_SECTION_DROP_PLACEHOLDER[rowColType];
      if (
        rowColWisePlaceholderPos &&
        rowColWisePlaceholderPos[positionType || "general"]
      ) {
        const placeholders = [];
        rowColWisePlaceholderPos[positionType || "general"].forEach(
          position => {
            const dropPlaceholder = this._getDropComponentPlaceholder(
              position,
              componentId,
              rowIndexPosition,
              colIndexPosition,
              isNewRow,
              dbRowIndex,
              dbColIndex,
            );
            // GET the placeholder for COLUMN
            if (rowColType === "COLUMN") {
              /**
               * Here we have to check two conditions,
               * 1. check if the dragged over component allows drop placeholder for position & for block type,
               * 2. check if the dragged over component allows drop of dragged component for position & for block type
               * */
              if (
                componentType &&
                SECTION_AND_POSITION_WISE_PLACEHOLDER[componentType][
                  blockType
                ].includes(position) &&
                SECTION_AND_POSITION_WISE_PLACEHOLDER[draggedSection.type][
                  blockType
                ].includes(position)
              ) {
                placeholders.push(dropPlaceholder);
              }
            }
            // GET the placeholder for ROW
            else if (
              rowColType === "ROW" &&
              SECTION_AND_POSITION_WISE_PLACEHOLDER[draggedSection.type][
                blockType
              ].includes(position)
            ) {
              placeholders.push(dropPlaceholder);
            }
          },
        );

        if (placeholders && placeholders.length > 0) {
          return placeholders;
        }
      }
    }
    return null;
  };

  _openTableColorpicker = () => {
    this.setState({
      tableColorpickerDropdown: true,
    });
  };

  _closeTableColorpicker = () => {
    this.setState({
      tableColorpickerDropdown: false,
    });
  };

  _getComponentView = (colIndex, component, totalRowItems, componentMeta) => (
    <ComponentView
      itemType={this.props.itemType}
      key={component.id}
      blockType={this.props.blockType}
      mode={this.props.mode}
      rowIndex={this.props.rowIndex}
      colIndex={colIndex}
      isLocked={this.props.isLocked}
      sectionID={component.id}
      componentMeta={componentMeta}
      component={component}
      addComponent={this.props.addComponent}
      updateComponent={this.props.updateComponent}
      cloneSection={this.props.cloneSection}
      totalRowItems={totalRowItems}
      // deleteComponent={this.props.deleteComponent}
      deleteComponent={deleteSectionID =>
        this.props.deleteComponent(deleteSectionID, component)
      }
      draggedSection={this.props.draggedSection}
      docComponentSectionList={this.props.docComponentSectionList}
      removeHighlightSelection={this.props.removeHighlightSelection}
      updateHoveredSectionId={this.props.updateHoveredSectionId}
      removeActiveComponents={this.props.removeActiveComponents}
      showDocumentDiffView={this.props.showDocumentDiffView}
      deleteSection={this.props.deleteSection}
      isSharedDocument={this.props.isSharedDocument}
      isDocumentLocked={this.props.isDocumentLocked}
      toggleSectionLockUnlock={this.props.handleSectionLockUnlock}
      hoveredActiveComponentId={this.props.hoveredActiveComponentId}
      disablePlusBtnHandler={this._disablePlusBtnHandler}
      // Refs related props
      customToolbarRef={this.props.customToolbarRef}
      signatureWrapperRef={this.props.signatureWrapperRef}
      setRefsByType={this.props.setRefsByType}
      // Template related props
      handleComponentLockUnlock={this.props.handleComponentLockUnlock}
      tableColorpickerDropdownRef={this.props.tableColorpickerDropdownRef}
      openTableColorpicker={this._openTableColorpicker}
      closeTableColorpicker={this._closeTableColorpicker}
      match={this.props.match}
    />
  );

  /**
   * GET COLUMN (COMPONENT BLOCK) WITH DROP & PLUS BUTTON PLACEHOLDERS
   * @param {*} colIndex  :: it is being used here to identify the first column
   * @param {*} component :: component Data
   */
  _getColumnView = (colIndex, componentId, totalRowItems, rowIndex) => {
    const colPositionType = colIndex === 0 ? "left-right" : "general";
    const { content: component } = this.props.components[componentId];

    if (!component) return null;

    const componentMeta = {
      ...this.props.componentMeta,
      componentType: component.type || component.section_type,
      componentId,
      colIndex,
      rowIndex,
    };

    const isDragggedOver = this._isDraggedOver(
      component.id || component.component_id,
      "COLUMN",
    );
    const sectionView = this._getComponentView(
      colIndex,
      component,
      totalRowItems,
      componentMeta,
    );
    /**
     * Here getting the "colClassName" for the following reasons,
     * 1. "drop-width-height-placeholder" :: When there is a dragged section then, adding css on all(left, right) drop placeholders,
     * 2. "showColPlusBtnClassName"       :: This is for showing the left and right plus buttons based on the hovered positions,
     * 3. "showResetPlusBtnClassName"     :: This is for showing left and right the plus buttons if section size is small(w<150px && H<150px)
     */
    let colClassName = "document-col-container ";
    if (this.props.draggedSection) {
      colClassName += " drop-width-height-placeholder";
    }
    if (this.state.hoveredComponentId === colIndex) {
      colClassName += ` ${this.state.showColPlusBtnClassName} `;
    }
    if (this.state.showResetPlusBtnClassName) {
      colClassName += " reset-col-plus-btn ";
    }

    let layoutSection = null;
    if (this.props.components[componentId]) {
      layoutSection = this.props.components[componentId];
    }
    if (sectionView) {
      return (
        <div
          id={`col-${component.id}`}
          className={colClassName}
          ref={ele => {
            this.documentComponentRefs[colIndex] = ele;
          }}
          onMouseMove={e => this._handleOnMouseOver(e, colIndex)}
          onBlur={() => {}}
          onFocus={() => {}}
          onDragOver={this._onPlaceholderDragOver}
          onDragEnter={event =>
            this._onPlaceholderDragEnter(
              event,
              {
                rowIndex: this.props.rowIndex,
                columnId: component.id,
                blockType: this.props.blockType,
              },
              "bottom",
            )
          }
          onDrop={event =>
            this._handleComponentBodyDrop(
              event,
              component.type,
              "bottom",
              this.props.rowIndex,
              colIndex,
              true, // isNewRow
              layoutSection ? layoutSection.dbRowIndex : 0,
              layoutSection ? layoutSection.dbColIndex : 0,
            )
          }>
          <div className="document-col">
            {sectionView}
            {/* -------- Column Ka Plus Button Placeholder -------- */}
            {this._getPlusButtonBlockPlaceholders(
              "COLUMN",
              component.id,
              colPositionType,
              component.type,
              this.props.rowIndex,
              colIndex,
              false, // isNewRow
              layoutSection ? layoutSection.dbRowIndex : 0,
              layoutSection ? layoutSection.dbColIndex : 0,
              totalRowItems,
            )}
            {/* -------- Column Ka Drop Placeholder -------- */}
            {this._getDropComponentPlaceholders(
              "COLUMN",
              colPositionType,
              component.type,
              component.id,
              isDragggedOver,
              this.props.rowIndex,
              colIndex,
              false, // isNewRow
              layoutSection ? layoutSection.dbRowIndex : 0,
              layoutSection ? layoutSection.dbColIndex : 0,
              totalRowItems,
            )}
          </div>
        </div>
      );
    }
    return null;
  };

  render() {
    const { rowList, rowIndex, components } = this.props;
    const rowView = [];
    let getDBRowIndex = null;
    // Get the valid column view of rowList
    if (Array.isArray(rowList) && rowList.length > 0) {
      rowList.forEach((componentId, colIndex) => {
        if (
          componentId &&
          components &&
          components[componentId] &&
          components[componentId].content &&
          // Here, we have to filter out the HeaderFooter/CoverPage
          !(
            components[componentId].content.type === "HeaderFooter" ||
            components[componentId].content.type === "CoverPage"
          )
        ) {
          if (getDBRowIndex === null) {
            getDBRowIndex = components[componentId].dbRowIndex;
          }
          rowView.push(
            this._getColumnView(
              colIndex,
              componentId,
              rowList.length,
              rowIndex,
            ),
          );
        }
      });
    }

    if (
      this.state.tableColorpickerDropdown &&
      this.state.clickedPlusBtnSectionId !== null &&
      this.state.clickedPlusBtnPosition !== null
    ) {
      this._closeTableColorpicker();
    }

    /**
     * Here getting the "rowClassName" for the following reasons,
     * 1. "drop-row-container"       :: When there is a dragged section then, adding css on top & bottom drop placeholders,
     * 2. "empty-drop-row-container" :: Adding the css for bottom drop placeholder in case of empty document,
     * 3. "showRowPlusBtnClassName"  :: This is for showing the top and bottom plus buttons based on the hovered positions,
     * 4. "reset-row-plus-btn"       :: This is for showing top and bottom the plus buttons if section size is small(w<150px && H<150px)
     */
    let rowClassName = "document-row-container ";
    if (this.props.draggedSection) {
      rowClassName += " drop-row-container ";
    }
    let rowPositionType = "general";
    // ::: EMPTY DOCUMENT CASE :::
    if (this.props.emptyBlockConfig && this.props.emptyBlockConfig.flag) {
      rowPositionType = "empty-doc";
      if (
        this.props.blockType === "HEADER" ||
        this.props.blockType === "FOOTER"
      ) {
        rowClassName =
          "document-row-container empty-drop-row-container header-footer ";
      } else {
        rowClassName = "document-row-container empty-drop-row-container ";
      }
    }
    if (this.state.showRowPlusBtnClassName) {
      rowClassName += ` ${this.state.showRowPlusBtnClassName} `;
    }
    if (this.state.showResetPlusBtnClassName) {
      rowClassName += " reset-row-plus-btn ";
    }
    const isDragggedOver = this._isDraggedOver(rowIndex, "ROW");
    if (Array.isArray(rowView) && rowView.length > 0) {
      return (
        <div className={rowClassName} id={rowIndex}>
          <div
            className={`document-row ${
              this.state.tableColorpickerDropdown &&
              this.state.clickedPlusBtnPosition === null &&
              this.state.clickedPlusBtnSectionId === null
                ? "color-picker-dropdown"
                : ""
            }`}>
            {rowView}
          </div>
          {/* -------- Row Ka Plus Button Placeholder -------- */}
          {this._getPlusButtonBlockPlaceholders(
            "ROW",
            rowIndex, // as a component Id
            rowPositionType,
            null,
            rowIndex, // as a row index
            0,
            true, // isNewRow
            getDBRowIndex,
          )}
          {/* --------Row Ka Drop Block Placeholder -------- */}
          {this._getDropComponentPlaceholders(
            "ROW",
            rowPositionType,
            null,
            rowIndex,
            isDragggedOver,
            rowIndex,
            0,
            true, // isNewRow
            getDBRowIndex,
          )}
        </div>
      );
    }
    return null;
  }
}

const mapStateToProps = state => {
  const { draggedFrom } = state.DocumentStore;
  return { draggedFrom };
};

export default connect(
  mapStateToProps,
  null,
)(DocumentRow);



// WEBPACK FOOTER //
// ./src/components/DocumentV2/DocumentBlocks/DocumentRow.js